/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"


/**
 * Сервис реализует функционал управления приложениями
 */

/**
 * Сервис управления приложениями для суперапа
 */
export class AppServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод сохранения приложения.
   * Поддерживает создание и обновление.
   * Сценарий использования метода: https://confluence.rt.ru/pages/viewpage.action?pageId=664695668.
   * Метод доступен для: admin, manager, service
   */
  PostApp = (req: PostAppRequestDto, init?: RequestInit): Promise<PostAppResponseDto> => {
    return fm.request<PostAppRequestDto, PostAppResponseDto>(`${this.host}/multiapp/api/v1/app`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения приложения.
   * Сценарий использования метода: https://confluence.rt.ru/pages/viewpage.action?pageId=682907591.
   * Метод доступен для: admin, manager, service, ltp_first
   */
  GetApp = (req: GetAppRequestDto, init?: RequestInit): Promise<GetAppResponseDto> => {
    return fm.request<GetAppRequestDto, GetAppResponseDto>(`${this.host}/multiapp/api/v1/app/${encodeURIComponent(req.id)}${fm.buildQuery(req, ["id"])}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения упрощённого приложения.
   * Не требует авторизации
   */
  GetAppLite = (req: GetAppLiteRequestDto, init?: RequestInit): Promise<GetAppLiteResponseDto> => {
    return fm.request<GetAppLiteRequestDto, GetAppLiteResponseDto>(`${this.host}/multiapp/api/v1/app_lite/${encodeURIComponent(req.id)}${fm.buildQuery(req, ["id"])}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения списка приложений.
   * Сценарий использования метода: https://confluence.rt.ru/pages/viewpage.action?pageId=682907591.
   * Метод доступен для: admin, manager, service, ltp_first
   */
  GetAppList = (req?: GetAppListRequestDto, init?: RequestInit): Promise<GetAppListResponseDto[]> => {
    return fm.list<GetAppListRequestDto, GetAppListResponseDto>(`${this.host}/multiapp/api/v1/app/list${fm.buildQuery(req)}`, {...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }
  /**
   * Метод получения списка упрощённых приложений.
   * Возвращает приложения не в статусе DELETED.
   * Если не передан параметр app_lite_tag.platform_type возвращает пустой список.
   * Если не передан параметр app_lite_tag.app_name возвращает пустой список.
   * Если не передан параметр user_tags, либо user_tags пустой, возвращает пустой список.
   * На основе переданных параметра app_lite_tag формируются app_tags по правилу: https://confluence.rt.ru/pages/viewpage.action?pageId=734713874.
   * Сценарий использования метода: https://confluence.rt.ru/pages/viewpage.action?pageId=664695692.
   * Не требует авторизации
   */
  GetAppLiteList = (req?: GetAppLiteListRequestDto, init?: RequestInit): Promise<GetAppLiteListResponseDto[]> => {
    return fm.list<GetAppLiteListRequestDto, GetAppLiteListResponseDto>(`${this.host}/multiapp/api/v1/app_lite/list${fm.buildQuery(req)}`, {...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }
  /**
   * Метод получения количества упрощённых приложений.
   * Учитывает приложения не в статусе DELETED.
   * Если не передан параметр app_lite_tag.platform_type возвращает 0.
   * Если не передан параметр app_lite_tag.app_name возвращает 0.
   * Если не передан параметр user_tags, либо user_tags пустой, возвращает 0.
   * На основе переданных параметра app_lite_tag формируются app_tags по правилу: https://confluence.rt.ru/pages/viewpage.action?pageId=734713874.
   * Не требует авторизации
   */
  GetAppLiteCount = (req?: GetAppLiteCountRequestDto, init?: RequestInit): Promise<GetAppLiteCountResponseDto> => {
    return fm.request<GetAppLiteCountRequestDto, GetAppLiteCountResponseDto>(`${this.host}/multiapp/api/v1/app_lite/count${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения количества приложений.
   * Сценарий использования метода: https://confluence.rt.ru/pages/viewpage.action?pageId=664695692.
   * Метод доступен для: admin, manager, service, ltp_first
   */
  GetAppCount = (req?: GetAppCountRequestDto, init?: RequestInit): Promise<GetAppCountResponseDto> => {
    return fm.request<GetAppCountRequestDto, GetAppCountResponseDto>(`${this.host}/multiapp/api/v1/app/count${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения кода для перехода в приложение.
   * Логика работы метода: https://confluence.rt.ru/pages/viewpage.action?pageId=664695692.
   * Метод доступен для: admin, service, master, slave
   */
  GetAppCode = (req: GetAppCodeRequestDto, init?: RequestInit): Promise<GetAppCodeResponseDto> => {
    return fm.request<GetAppCodeRequestDto, GetAppCodeResponseDto>(`${this.host}/multiapp/api/v1/app/${encodeURIComponent(req.id)}/code${fm.buildQuery(req, ["id"])}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод удаления приложения.
   * Soft delete, из базы не удаляется, проставляется статус.
   * Сценарий использования метода: https://confluence.rt.ru/pages/viewpage.action?pageId=682907591.
   * Метод доступен для: admin, manager, service
   */
  DeleteApp = (req: DeleteAppRequestDto, init?: RequestInit): Promise<DeleteAppResponseDto> => {
    return fm.request<DeleteAppRequestDto, DeleteAppResponseDto>(`${this.host}/multiapp/api/v1/app/${encodeURIComponent(req.id)}${fm.buildQuery(req, ["id"])}`, { ...init, method: "DELETE", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Справочник разрешений
 */
export enum AppGrantType {
  /**
   * Значение не указано
   */
  GRANT_TYPE_UNKNOWN = "GRANT_TYPE_UNKNOWN",
  /**
   * Разрешение на получение авторизационного токена посредством метода GET /multiapp/api/v1/partner/token
   */
  GET_ACCESS_TOKEN = "GET_ACCESS_TOKEN",
  /**
   * Разрешение на получение идентификационного доступа посредством метода GET /multiapp/api/v1/partner/token
   */
  GET_ID_TOKEN = "GET_ID_TOKEN",
  /**
   * Разрешение на отправку уведомлений без проверки назначений приложения методом POST /multiapp/api/v1/notification
   */
  POST_NOTIF_NO_ASSIGN_CHECK = "POST_NOTIF_NO_ASSIGN_CHECK",
}
/**
 * Справочник разрешений
 */
export type AppGrantTypeResponseEnum = keyof typeof AppGrantType
/**
 * Справочник разрешений
 */
export type AppGrantTypeRequestEnum = Exclude<AppGrantTypeResponseEnum, "GRANT_TYPE_UNKNOWN">;

/**
 * Справочник типов ссылок.
 */
export enum AppLinkType {
  /**
   * Значение не указано
   */
  TYPE_UNKNOWN = "TYPE_UNKNOWN",
  /**
   * Ссылка для перехода на раздел текущего приложения
   */
  INTERNAL_APP = "INTERNAL_APP",
  /**
   * Ссылка для перехода на стороннее приложение
   */
  EXTERNAL_APP = "EXTERNAL_APP",
  /**
   * Ссылка для перехода на веб-вью внутренних (своих) приложений.
   * В окне отсутствует адресаная строка.
   * Для iOS используется WKWebView, для Android используется WebView
   */
  WEB_VIEW = "WEB_VIEW",
  /**
   * Ссылка для перехода на веб-браузер
   */
  WEB_BROWSER = "WEB_BROWSER",
  /**
   * Ссылка для перехода на веб-вью внешних (партнёрских) приложений.
   * В окне присутствует адресаная строка.
   * Для iOS используется SFSafariViewController, для Android используется ChromeCustomTabs
   */
  EXTERNAL_WEB_VIEW = "EXTERNAL_WEB_VIEW",
}
/**
 * Справочник типов ссылок.
 */
export type AppLinkTypeResponseEnum = keyof typeof AppLinkType
/**
 * Справочник типов ссылок.
 */
export type AppLinkTypeRequestEnum = Exclude<AppLinkTypeResponseEnum, "TYPE_UNKNOWN">;

/**
 * Справочник разрешенных типов токена
 */
export enum AppPermissionsAllowedTokenType {
  /**
   * Значение не указано
   */
  ALLOWED_TOKEN_TYPE_UNKNOWN = "ALLOWED_TOKEN_TYPE_UNKNOWN",
  /**
   * Идентификационный
   */
  ID = "ID",
  /**
   * Авторизационный
   */
  ACCESS = "ACCESS",
}
/**
 * Справочник разрешенных типов токена
 */
export type AppPermissionsAllowedTokenTypeResponseEnum = keyof typeof AppPermissionsAllowedTokenType
/**
 * Справочник разрешенных типов токена
 */
export type AppPermissionsAllowedTokenTypeRequestEnum = Exclude<AppPermissionsAllowedTokenTypeResponseEnum, "ALLOWED_TOKEN_TYPE_UNKNOWN">;

/**
 * Справочник платформ.
 */
export enum AppPlatformType {
  /**
   * Значение не указано
   */
  PLATFORM_TYPE_UNKNOWN = "PLATFORM_TYPE_UNKNOWN",
  /**
   * Платформа iOS.
   * Приложение размещается в App Store
   */
  IOS = "IOS",
  /**
   * Платформа Android.
   * Приложение размещается в Google Play, App Gallery или прочих сторах
   */
  ANDROID = "ANDROID",
  /**
   * Платформа Web.
   * Приложение размещается по интернет адресу
   */
  WEB = "WEB",
}
/**
 * Справочник платформ.
 */
export type AppPlatformTypeResponseEnum = keyof typeof AppPlatformType
/**
 * Справочник платформ.
 */
export type AppPlatformTypeRequestEnum = Exclude<AppPlatformTypeResponseEnum, "PLATFORM_TYPE_UNKNOWN">;

/**
 * Справочник статусов приложений.
 */
export enum AppStatusType {
  /**
   * Значение не указано
   */
  STATUS_TYPE_UNKNOWN = "STATUS_TYPE_UNKNOWN",
  /**
   * Заблокирован
   */
  BLOCKED = "BLOCKED",
  /**
   * Активен
   */
  ACTIVE = "ACTIVE",
  /**
   * Удален
   */
  DELETED = "DELETED",
}
/**
 * Справочник статусов приложений.
 */
export type AppStatusTypeResponseEnum = keyof typeof AppStatusType
/**
 * Справочник статусов приложений.
 */
export type AppStatusTypeRequestEnum = Exclude<AppStatusTypeResponseEnum, "STATUS_TYPE_UNKNOWN">;

/**
 * Справочник типов приложений.
 */
export enum AppType {
  /**
   * Значение не указано
   */
  TYPE_UNKNOWN = "TYPE_UNKNOWN",
  /**
   * Стандартное приложение
   */
  STANDARD = "STANDARD",
}
/**
 * Справочник типов приложений.
 */
export type AppTypeResponseEnum = keyof typeof AppType
/**
 * Справочник типов приложений.
 */
export type AppTypeRequestEnum = Exclude<AppTypeResponseEnum, "TYPE_UNKNOWN">;

/**
 * Справочник типов направлений сортировки.
 */
export enum AppLitePagingDirectionType {
  /**
   * Значение не указано
   */
  DIRECTION_TYPE_UNKNOWN = "DIRECTION_TYPE_UNKNOWN",
  /**
   * От большего к меньшему
   */
  DESC = "DESC",
  /**
   * От меньшего к большему
   */
  ASC = "ASC",
}
/**
 * Справочник типов направлений сортировки.
 */
export type AppLitePagingDirectionTypeResponseEnum = keyof typeof AppLitePagingDirectionType
/**
 * Справочник типов направлений сортировки.
 */
export type AppLitePagingDirectionTypeRequestEnum = Exclude<AppLitePagingDirectionTypeResponseEnum, "DIRECTION_TYPE_UNKNOWN">;

/**
 * Справочник типов значений сортировки.
 */
export enum AppLitePagingOrderByType {
  /**
   * Значение не указано
   */
  ORDER_BY_TYPE_UNKNOWN = "ORDER_BY_TYPE_UNKNOWN",
  /**
   * Дата последнего изменения
   */
  CHANGED_AT = "CHANGED_AT",
  /**
   * Дата создания
   */
  CREATED_AT = "CREATED_AT",
}
/**
 * Справочник типов значений сортировки.
 */
export type AppLitePagingOrderByTypeResponseEnum = keyof typeof AppLitePagingOrderByType
/**
 * Справочник типов значений сортировки.
 */
export type AppLitePagingOrderByTypeRequestEnum = Exclude<AppLitePagingOrderByTypeResponseEnum, "ORDER_BY_TYPE_UNKNOWN">;

/**
 * Справочник типов направлений сортировки.
 */
export enum AppPagingDirectionType {
  /**
   * Значение не указано
   */
  DIRECTION_TYPE_UNKNOWN = "DIRECTION_TYPE_UNKNOWN",
  /**
   * От большего к меньшему
   */
  DESC = "DESC",
  /**
   * От меньшего к большему
   */
  ASC = "ASC",
}
/**
 * Справочник типов направлений сортировки.
 */
export type AppPagingDirectionTypeResponseEnum = keyof typeof AppPagingDirectionType
/**
 * Справочник типов направлений сортировки.
 */
export type AppPagingDirectionTypeRequestEnum = Exclude<AppPagingDirectionTypeResponseEnum, "DIRECTION_TYPE_UNKNOWN">;

/**
 * Справочник типов значений сортировки.
 */
export enum AppPagingOrderByType {
  /**
   * Значение не указано
   */
  ORDER_BY_TYPE_UNKNOWN = "ORDER_BY_TYPE_UNKNOWN",
  /**
   * Дата последнего изменения
   */
  CHANGED_AT = "CHANGED_AT",
  /**
   * Дата создания
   */
  CREATED_AT = "CREATED_AT",
  /**
   * По рангу для поиска по тексту.
   * Применяется когда передано поле для поиска по тексту.
   * В случае если текстовое поле не передано, применяется значение по умолчанию
   */
  RANK = "RANK",
}
/**
 * Справочник типов значений сортировки.
 */
export type AppPagingOrderByTypeResponseEnum = keyof typeof AppPagingOrderByType
/**
 * Справочник типов значений сортировки.
 */
export type AppPagingOrderByTypeRequestEnum = Exclude<AppPagingOrderByTypeResponseEnum, "ORDER_BY_TYPE_UNKNOWN">;

/**
 * Приложение.
 * # Описание модели
 */
export type AppRequestDto = {
  /**
   * Идентификатор.
   * Если не передан создаётся сервером.
   * # Тип: Guid
   */
  id?: string
  /**
   * Идентификатор партнера.
   * # Тип: Guid
   */
  partnerId: string
  /**
   * Тип приложения
   */
  type: AppTypeRequestEnum
  /**
   * Системное наименование.
   * Не отображается пользователям.
   * # Диапазон: 3..256
   */
  title: string
  /**
   * Заголовок.
   * # Диапазон: 3..30
   */
  header?: string | null
  /**
   * Подзаголовок.
   * # Диапазон: 3..60
   */
  subtitle?: string | null
  /**
   * Цвет заднего плана(подложки).
   * Все цвета должны быть в формате hex #RRGGBBAA.
   * Пример: #7e00c380.
   * # Диапазон: 9..9.
   * # Паттерн: /^#[0-9a-fA-F]{8}$/
   */
  backgroundColor?: string | null
  /**
   * Статус приложения
   */
  statusType: AppStatusTypeRequestEnum
  /**
   * Ссылки для переходов.
   * # Диапазон: 0..100
   */
  links?: AppLinkRequestDto[]
  /**
   * Список тегов пользователей.
   * Обязательное.
   * Описывает кто может видеть приложение.
   * Тэг - максимум 5 символов, значение - максимум 19 символов, количество сегментов - максимум 10.
   * # Диапазон: 1..100.
   * # Паттерн: /^[A-Z-]{1,5}_[0-9A-Z-]{1,19}(?:\.[A-Z-]{1,5}_[0-9A-Z-]{1,19}){0,9}$/
   */
  userTags: string[]
  /**
   * Список тегов приложений.
   * Обязательное.
   * Описывает какие клиенты могут видеть приложение.
   * Тэг - максимум 5 символов, значение - максимум 19 символов, количество сегментов - максимум 10.
   * # Диапазон: 1..20.
   * # Паттерн: /^[A-Z-]{1,5}_[0-9A-Z-]{1,19}(?:\.[A-Z-]{1,5}_[0-9A-Z-]{1,19}){0,9}$/
   */
  appTags: string[]
  /**
   * Дата последнего изменения.
   * Заполняется и обновляется сервером.
   * При изменении должен совпадать со значением из БД.
   * Является версией объекта.
   * # Тип: DateTime
   */
  changedAt?: string | null
  /**
   * Разрешения
   * @deprecated
   */
  permissions?: AppPermissionsRequestDto | null
  /**
   * Список разрешений
   */
  grantTypes?: AppGrantTypeRequestEnum[]
}
/**
 * Приложение.
 * # Описание модели
 */
export type AppResponseDto = {
  /**
   * Идентификатор.
   * Если не передан создаётся сервером.
   * # Тип: Guid
   */
  id: string
  /**
   * Идентификатор партнера.
   * # Тип: Guid
   */
  partnerId: string
  /**
   * Тип приложения
   */
  type: AppTypeResponseEnum
  /**
   * Системное наименование.
   * Не отображается пользователям.
   * # Диапазон: 3..256
   */
  title: string
  /**
   * Заголовок.
   * # Диапазон: 3..30
   */
  header: string | null
  /**
   * Подзаголовок.
   * # Диапазон: 3..60
   */
  subtitle: string | null
  /**
   * Цвет заднего плана(подложки).
   * Все цвета должны быть в формате hex #RRGGBBAA.
   * Пример: #7e00c380.
   * # Диапазон: 9..9.
   * # Паттерн: /^#[0-9a-fA-F]{8}$/
   */
  backgroundColor: string | null
  /**
   * Статус приложения
   */
  statusType: AppStatusTypeResponseEnum
  /**
   * Ссылки для переходов.
   * # Диапазон: 0..100
   */
  links: AppLinkResponseDto[]
  /**
   * Список тегов пользователей.
   * Обязательное.
   * Описывает кто может видеть приложение.
   * Тэг - максимум 5 символов, значение - максимум 19 символов, количество сегментов - максимум 10.
   * # Диапазон: 1..100.
   * # Паттерн: /^[A-Z-]{1,5}_[0-9A-Z-]{1,19}(?:\.[A-Z-]{1,5}_[0-9A-Z-]{1,19}){0,9}$/
   */
  userTags: string[]
  /**
   * Список тегов приложений.
   * Обязательное.
   * Описывает какие клиенты могут видеть приложение.
   * Тэг - максимум 5 символов, значение - максимум 19 символов, количество сегментов - максимум 10.
   * # Диапазон: 1..20.
   * # Паттерн: /^[A-Z-]{1,5}_[0-9A-Z-]{1,19}(?:\.[A-Z-]{1,5}_[0-9A-Z-]{1,19}){0,9}$/
   */
  appTags: string[]
  /**
   * Дата создания.
   * # Тип: DateTime
   */
  readonly createdAt: string
  /**
   * Дата последнего изменения.
   * Заполняется и обновляется сервером.
   * При изменении должен совпадать со значением из БД.
   * Является версией объекта.
   * # Тип: DateTime
   */
  changedAt: string
  /**
   * Разрешения
   * @deprecated
   */
  permissions: AppPermissionsResponseDto | null
  /**
   * Список разрешений
   */
  grantTypes: AppGrantTypeResponseEnum[]
}
/**
 * Ссылка
 */
export type AppLinkRequestDto = {
  /**
   * Тип платформы.
   * Обязательное
   */
  platformType: AppPlatformTypeRequestEnum
  /**
   * Тип ссылки.
   * Обязательное
   */
  type: AppLinkTypeRequestEnum
  /**
   * Значение ссылки для перехода.
   * Обязательное.
   * # Диапазон: 12..512
   */
  url: string
  /**
   * Список пакетов.
   * Если пусто попытка перехода осуществляется безусловно.
   * Если заполнено, то переход осуществляется только в случае если хоть один пакет есть на устройстве, иначе обработка переходит к следующей ссылке.
   * # Диапазон: 0..20
   */
  packages?: string[]
}
/**
 * Ссылка
 */
export type AppLinkResponseDto = {
  /**
   * Тип платформы.
   * Обязательное
   */
  platformType: AppPlatformTypeResponseEnum
  /**
   * Тип ссылки.
   * Обязательное
   */
  type: AppLinkTypeResponseEnum
  /**
   * Значение ссылки для перехода.
   * Обязательное.
   * # Диапазон: 12..512
   */
  url: string
  /**
   * Список пакетов.
   * Если пусто попытка перехода осуществляется безусловно.
   * Если заполнено, то переход осуществляется только в случае если хоть один пакет есть на устройстве, иначе обработка переходит к следующей ссылке.
   * # Диапазон: 0..20
   */
  packages: string[]
}
/**
 * Разрешения
 */
export type AppPermissionsRequestDto = {
  /**
   * Список разрешенных типов токена
   */
  allowedTokenTypes?: AppPermissionsAllowedTokenTypeRequestEnum[]
}
/**
 * Разрешения
 */
export type AppPermissionsResponseDto = {
  /**
   * Список разрешенных типов токена
   */
  allowedTokenTypes: AppPermissionsAllowedTokenTypeResponseEnum[]
}
/**
 * Ошибка сохранения.
 * Эти проверки выполняются при работе с базой данных и сторонними сервисами
 */
export type AppSavingErrorRequestDto = {
}
/**
 * reason
 */
& fm.OptionalOneOf<{
  /**
   * Конфликт версий
   */
  readonly conflict: AppSavingErrorConflictRequestDto
  /**
   * Переданный партнер не существует
   */
  readonly partnerIsNotExist: AppSavingErrorPartnerIsNotExistRequestDto
  /**
   * Переданный партнер удален
   */
  readonly partnerIsDeleted: AppSavingErrorPartnerIsDeletedRequestDto
}>
/**
 * Ошибка сохранения.
 * Эти проверки выполняются при работе с базой данных и сторонними сервисами
 */
export type AppSavingErrorResponseDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Конфликт версий
   */
  readonly conflict: AppSavingErrorConflictResponseDto
  /**
   * Переданный партнер не существует
   */
  readonly partnerIsNotExist: AppSavingErrorPartnerIsNotExistResponseDto
  /**
   * Переданный партнер удален
   */
  readonly partnerIsDeleted: AppSavingErrorPartnerIsDeletedResponseDto
}>
/**
 * Конфликт версий.
 * Причины:
 * - В базе хранится другая версия строки, значения changed_at отличаются
 */
export type AppSavingErrorConflictRequestDto = {
}
/**
 * Конфликт версий.
 * Причины:
 * - В базе хранится другая версия строки, значения changed_at отличаются
 */
export type AppSavingErrorConflictResponseDto = {
}
/**
 * Переданный партнер удален.
 * Причины:
 * - В базе удален партнер с переданным partner_id
 */
export type AppSavingErrorPartnerIsDeletedRequestDto = {
}
/**
 * Переданный партнер удален.
 * Причины:
 * - В базе удален партнер с переданным partner_id
 */
export type AppSavingErrorPartnerIsDeletedResponseDto = {
}
/**
 * Переданный партнер не существует.
 * Причины:
 * - В базе нет партнера с переданным partner_id
 */
export type AppSavingErrorPartnerIsNotExistRequestDto = {
}
/**
 * Переданный партнер не существует.
 * Причины:
 * - В базе нет партнера с переданным partner_id
 */
export type AppSavingErrorPartnerIsNotExistResponseDto = {
}
/**
 * Фильтр приложений
 */
export type AppFilterRequestDto = {
  /**
   * По тексту.
   * Если значение не передано то поиск по нему не производится.
   * # Диапазон: 3..64.
   * # Поиск производится по полям:
   * # - Системное наименование;
   * # - Заголовок;
   * # - Подзаголовок;
   * # - Список тегов пользователей;
   * # - Список тегов приложений
   */
  text?: string | null
  /**
   * По типам приложений
   */
  types?: AppTypeResponseEnum[]
  /**
   * По идентификаторам партнера.
   * # Тип: Guid
   */
  partnerIds?: string[]
  /**
   * По статусам приложений.
   * Если переданы все типы, то фильтр игнорируется(так как нужно вернуть всё)
   */
  statusTypes?: AppStatusTypeResponseEnum[]
  /**
   * По пользовательским тегам.
   * Тэг - максимум 5 символов, значение - максимум 19 символов, количество сегментов - максимум 10.
   * # Диапазон: 0..20.
   * # Паттерн: /^[A-Z-]{1,5}_[0-9A-Z-]{1,19}(?:\.[A-Z-]{1,5}_[0-9A-Z-]{1,19}){0,9}$/
   */
  userTags?: string[]
  /**
   * По тегам приложений.
   * Тэг - максимум 5 символов, значение - максимум 19 символов, количество сегментов - максимум 10.
   * # Диапазон: 0..20.
   * # Паттерн: /^[A-Z-]{1,5}_[0-9A-Z-]{1,19}(?:\.[A-Z-]{1,5}_[0-9A-Z-]{1,19}){0,9}$/
   */
  appTags?: string[]
}
/**
 * Фильтр приложений
 */
export type AppFilterResponseDto = {
  /**
   * По тексту.
   * Если значение не передано то поиск по нему не производится.
   * # Диапазон: 3..64.
   * # Поиск производится по полям:
   * # - Системное наименование;
   * # - Заголовок;
   * # - Подзаголовок;
   * # - Список тегов пользователей;
   * # - Список тегов приложений
   */
  text: string | null
  /**
   * По типам приложений
   */
  types: AppTypeResponseEnum[]
  /**
   * По идентификаторам партнера.
   * # Тип: Guid
   */
  partnerIds: string[]
  /**
   * По статусам приложений.
   * Если переданы все типы, то фильтр игнорируется(так как нужно вернуть всё)
   */
  statusTypes: AppStatusTypeResponseEnum[]
  /**
   * По пользовательским тегам.
   * Тэг - максимум 5 символов, значение - максимум 19 символов, количество сегментов - максимум 10.
   * # Диапазон: 0..20.
   * # Паттерн: /^[A-Z-]{1,5}_[0-9A-Z-]{1,19}(?:\.[A-Z-]{1,5}_[0-9A-Z-]{1,19}){0,9}$/
   */
  userTags: string[]
  /**
   * По тегам приложений.
   * Тэг - максимум 5 символов, значение - максимум 19 символов, количество сегментов - максимум 10.
   * # Диапазон: 0..20.
   * # Паттерн: /^[A-Z-]{1,5}_[0-9A-Z-]{1,19}(?:\.[A-Z-]{1,5}_[0-9A-Z-]{1,19}){0,9}$/
   */
  appTags: string[]
}
/**
 * Облегчённое приложение
 */
export type AppLiteRequestDto = {
  /**
   * Идентификатор.
   * # Тип: Guid
   */
  id?: string
  /**
   * Наименование.
   * Не отображается пользователям.
   * # Диапазон: 3..256
   */
  title: string
  /**
   * Заголовок.
   * # Диапазон: 3..30
   */
  header?: string | null
  /**
   * Подзаголовок.
   * # Диапазон: 3..60
   */
  subtitle?: string | null
  /**
   * Цвет заднего плана(подложки).
   * Все цвета должны быть в формате hex #RRGGBBAA.
   * Пример: #7e00c380.
   * # Диапазон: 9..9.
   * # Паттерн: /^#[0-9a-fA-F]{8}$/
   */
  backgroundColor?: string | null
  /**
   * Статус приложения
   */
  statusType: AppStatusTypeRequestEnum
  /**
   * Ссылки для переходов
   */
  links?: AppLiteLinkLiteRequestDto[]
}
/**
 * Облегчённое приложение
 */
export type AppLiteResponseDto = {
  /**
   * Идентификатор.
   * # Тип: Guid
   */
  id: string
  /**
   * Наименование.
   * Не отображается пользователям.
   * # Диапазон: 3..256
   */
  title: string
  /**
   * Заголовок.
   * # Диапазон: 3..30
   */
  header: string | null
  /**
   * Подзаголовок.
   * # Диапазон: 3..60
   */
  subtitle: string | null
  /**
   * Цвет заднего плана(подложки).
   * Все цвета должны быть в формате hex #RRGGBBAA.
   * Пример: #7e00c380.
   * # Диапазон: 9..9.
   * # Паттерн: /^#[0-9a-fA-F]{8}$/
   */
  backgroundColor: string | null
  /**
   * Статус приложения
   */
  statusType: AppStatusTypeResponseEnum
  /**
   * Ссылки для переходов
   */
  links: AppLiteLinkLiteResponseDto[]
}
/**
 * Упрощённая ссылка
 */
export type AppLiteLinkLiteRequestDto = {
  /**
   * Тип платформы.
   * Обязательное
   */
  platformType: AppPlatformTypeRequestEnum
  /**
   * Тип ссылки.
   * Обязательное
   */
  type: AppLinkTypeRequestEnum
  /**
   * Значение ссылки для перехода.
   * Обязательное
   */
  url: string
  /**
   * Список пакетов.
   * Если пусто попытка перехода осуществляется безусловно.
   * Если заполнено, то переход осуществляется только в случае если хоть один пакет есть на устройстве, иначе обработка переходит к следующей ссылке
   */
  packages?: string[]
}
/**
 * Упрощённая ссылка
 */
export type AppLiteLinkLiteResponseDto = {
  /**
   * Тип платформы.
   * Обязательное
   */
  platformType: AppPlatformTypeResponseEnum
  /**
   * Тип ссылки.
   * Обязательное
   */
  type: AppLinkTypeResponseEnum
  /**
   * Значение ссылки для перехода.
   * Обязательное
   */
  url: string
  /**
   * Список пакетов.
   * Если пусто попытка перехода осуществляется безусловно.
   * Если заполнено, то переход осуществляется только в случае если хоть один пакет есть на устройстве, иначе обработка переходит к следующей ссылке
   */
  packages: string[]
}
/**
 * Упрощённый фильтр по приложениям
 */
export type AppLiteFilterRequestDto = {
  /**
   * По типам приложений
   */
  types?: AppTypeResponseEnum[]
  /**
   * По тегам пользователя.
   * Тэг - максимум 5 символов, значение - максимум 19 символов, количество сегментов - максимум 10.
   * # Диапазон: 1..20.
   * # Паттерн: /^[A-Z-]{1,5}_[0-9A-Z-]{1,19}(?:\.[A-Z-]{1,5}_[0-9A-Z-]{1,19}){0,9}$/
   */
  userTags?: string[]
  /**
   * Тег для приложения
   */
  appLiteTag?: AppLiteFilterAppLiteTagRequestDto | null
}
/**
 * Упрощённый фильтр по приложениям
 */
export type AppLiteFilterResponseDto = {
  /**
   * По типам приложений
   */
  types: AppTypeResponseEnum[]
  /**
   * По тегам пользователя.
   * Тэг - максимум 5 символов, значение - максимум 19 символов, количество сегментов - максимум 10.
   * # Диапазон: 1..20.
   * # Паттерн: /^[A-Z-]{1,5}_[0-9A-Z-]{1,19}(?:\.[A-Z-]{1,5}_[0-9A-Z-]{1,19}){0,9}$/
   */
  userTags: string[]
  /**
   * Тег для приложения
   */
  appLiteTag: AppLiteFilterAppLiteTagResponseDto | null
}
/**
 * Тег для приложения
 */
export type AppLiteFilterAppLiteTagRequestDto = {
  /**
   * Тип платформы
   */
  platformType?: AppPlatformTypeRequestEnum | "PLATFORM_TYPE_UNKNOWN"
  /**
   * Название приложения, которое работает с данным сервисом.
   * Для МП и PWA значение \"1\".
   * # Паттерн: /^[0-9A-Z-]{1,19}$/
   */
  appName?: string | null
}
/**
 * Тег для приложения
 */
export type AppLiteFilterAppLiteTagResponseDto = {
  /**
   * Тип платформы
   */
  platformType: AppPlatformTypeResponseEnum
  /**
   * Название приложения, которое работает с данным сервисом.
   * Для МП и PWA значение \"1\".
   * # Паттерн: /^[0-9A-Z-]{1,19}$/
   */
  appName: string | null
}
/**
 * Пагинация упрощенных приложений
 */
export type AppLitePagingRequestDto = {
  /**
   * Тип значения сортировки.
   * Если значение не передано, то будет взято значение по умолчанию.
   * # По умолчанию: CREATED_AT
   */
  orderByType?: AppLitePagingOrderByTypeRequestEnum | "ORDER_BY_TYPE_UNKNOWN"
  /**
   * Тип направления сортировки.
   * # По умолчанию: DESC
   */
  directionType?: AppLitePagingDirectionTypeRequestEnum | "DIRECTION_TYPE_UNKNOWN"
  /**
   * Количество записей на страницу.
   * Если значение 0 (не передано), то будет взято значение по умолчанию.
   * # Диапазон: 0..100.
   * # По умолчанию: 20
   */
  limit?: number
  /**
   * Сдвиг.
   * # Диапазон: 0..2147483647
   */
  offset?: number
}
/**
 * Пагинация упрощенных приложений
 */
export type AppLitePagingResponseDto = {
  /**
   * Тип значения сортировки.
   * Если значение не передано, то будет взято значение по умолчанию.
   * # По умолчанию: CREATED_AT
   */
  orderByType: AppLitePagingOrderByTypeResponseEnum
  /**
   * Тип направления сортировки.
   * # По умолчанию: DESC
   */
  directionType: AppLitePagingDirectionTypeResponseEnum
  /**
   * Количество записей на страницу.
   * Если значение 0 (не передано), то будет взято значение по умолчанию.
   * # Диапазон: 0..100.
   * # По умолчанию: 20
   */
  limit: number
  /**
   * Сдвиг.
   * # Диапазон: 0..2147483647
   */
  offset: number
}
/**
 * Пагинация приложений
 */
export type AppPagingRequestDto = {
  /**
   * Тип значения сортировки.
   * Если значение не передано, то будет взято значение по умолчанию.
   * # По умолчанию: CHANGED_AT
   */
  orderByType?: AppPagingOrderByTypeRequestEnum | "ORDER_BY_TYPE_UNKNOWN"
  /**
   * Тип направления сортировки.
   * # По умолчанию: DESC
   */
  directionType?: AppPagingDirectionTypeRequestEnum | "DIRECTION_TYPE_UNKNOWN"
  /**
   * Количество записей на страницу.
   * Если значение 0 (не передано), то будет взято значение по умолчанию.
   * # Диапазон: 0..100.
   * # По умолчанию: 20
   */
  limit?: number
  /**
   * Сдвиг.
   * # Диапазон: 0..2147483647
   */
  offset?: number
}
/**
 * Пагинация приложений
 */
export type AppPagingResponseDto = {
  /**
   * Тип значения сортировки.
   * Если значение не передано, то будет взято значение по умолчанию.
   * # По умолчанию: CHANGED_AT
   */
  orderByType: AppPagingOrderByTypeResponseEnum
  /**
   * Тип направления сортировки.
   * # По умолчанию: DESC
   */
  directionType: AppPagingDirectionTypeResponseEnum
  /**
   * Количество записей на страницу.
   * Если значение 0 (не передано), то будет взято значение по умолчанию.
   * # Диапазон: 0..100.
   * # По умолчанию: 20
   */
  limit: number
  /**
   * Сдвиг.
   * # Диапазон: 0..2147483647
   */
  offset: number
}
/**
 * Запрос удаления приложения
 */
export type DeleteAppRequestDto = {
  /**
   * Идентификатор приложения.
   * # Тип: Guid
   */
  id: string
}
/**
 * Ответ на запрос удаления приложения
 */
export type DeleteAppResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка
   */
  readonly error: DeleteAppResponseErrorDto
}>
/**
 * Ошибка запроса получения упрощённого приложения
 */
export type DeleteAppResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorRequestDto
}>
/**
 * Ошибка запроса получения упрощённого приложения
 */
export type DeleteAppResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorResponseDto
}>
/**
 * Запрос на получение кода для перехода в приложение
 */
export type GetAppCodeRequestDto = {
  /**
   * Идентификатор приложения.
   * # Тип: Guid
   */
  id: string
}
/**
 * Ответ на запрос на получение кода для перехода в приложение
 */
export type GetAppCodeResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Код
   */
  readonly data: string
  /**
   * Ошибка
   */
  readonly error: GetAppCodeResponseErrorDto
}>
/**
 * Ошибка запроса получения ссылки на приложение
 */
export type GetAppCodeResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorRequestDto
  /**
   * Ошибка наличия публичного ключа у партнера
   */
  readonly partnerKeyDoesNotExist: GetAppCodeResponseErrorPartnerKeyDoesNotExistRequestDto
  /**
   * Приложение не в статусе ACTIVE
   */
  readonly appIsInactive: GetAppCodeResponseErrorAppIsInactiveRequestDto
}>
/**
 * Ошибка запроса получения ссылки на приложение
 */
export type GetAppCodeResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorResponseDto
  /**
   * Ошибка наличия публичного ключа у партнера
   */
  readonly partnerKeyDoesNotExist: GetAppCodeResponseErrorPartnerKeyDoesNotExistDto
  /**
   * Приложение не в статусе ACTIVE
   */
  readonly appIsInactive: GetAppCodeResponseErrorAppIsInactiveDto
}>
/**
 * Приложение не в статусе ACTIVE
 */
export type GetAppCodeResponseErrorAppIsInactiveRequestDto = {
}
/**
 * Приложение не в статусе ACTIVE
 */
export type GetAppCodeResponseErrorAppIsInactiveDto = {
}
/**
 * Ошибка наличия публичного ключа у партнера
 */
export type GetAppCodeResponseErrorPartnerKeyDoesNotExistRequestDto = {
}
/**
 * Ошибка наличия публичного ключа у партнера
 */
export type GetAppCodeResponseErrorPartnerKeyDoesNotExistDto = {
}
/**
 * Запрос получения количества приложений
 */
export type GetAppCountRequestDto = {
  /**
   * Фильтр
   */
  filter?: AppFilterRequestDto | null
}
/**
 * Ответ на запрос получения количества приложений
 */
export type GetAppCountResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Всего приложений
   */
  readonly data: number
  /**
   * Ошибка
   */
  readonly error: GetAppCountResponseErrorDto
}>
/**
 * Ошибка запроса получения количества приложений
 */
export type GetAppCountResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorRequestDto
}>
/**
 * Ошибка запроса получения количества приложений
 */
export type GetAppCountResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorResponseDto
}>
/**
 * Запрос получения списка приложений
 */
export type GetAppListRequestDto = {
  /**
   * Фильтр
   */
  filter?: AppFilterRequestDto | null
}
/**
 * pagination
 */
& fm.OptionalOneOf<{
  /**
   * Пагинация
   */
  readonly paging: AppPagingRequestDto
}>
/**
 * Ответ на запрос получения списка приложений
 */
export type GetAppListResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Приложение
   */
  readonly data: AppResponseDto
  /**
   * Ошибка
   */
  readonly error: GetAppListResponseErrorDto
}>
/**
 * Ошибка запроса получения списка приложений
 */
export type GetAppListResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorRequestDto
}>
/**
 * Ошибка запроса получения списка приложений
 */
export type GetAppListResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorResponseDto
}>
/**
 * Запрос получения количества упрощённых приложений
 */
export type GetAppLiteCountRequestDto = {
  /**
   * Упрощённый фильтр
   */
  filter?: AppLiteFilterRequestDto | null
}
/**
 * Ответ на запрос получения количества упрощённых приложений
 */
export type GetAppLiteCountResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Всего упрощенных приложений
   */
  readonly data: number
  /**
   * Ошибка
   */
  readonly error: GetAppLiteCountResponseErrorDto
}>
/**
 * Ошибка запроса получения списка приложений
 */
export type GetAppLiteCountResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorRequestDto
}>
/**
 * Ошибка запроса получения списка приложений
 */
export type GetAppLiteCountResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorResponseDto
}>
/**
 * Запрос получения списка упрощённого приложений
 */
export type GetAppLiteListRequestDto = {
  /**
   * Упрощённый фильтр
   */
  filter?: AppLiteFilterRequestDto | null
}
/**
 * pagination
 */
& fm.OptionalOneOf<{
  /**
   * Пагинация
   */
  readonly paging: AppLitePagingRequestDto
}>
/**
 * Ответ на запрос получения списка упрощённых приложений
 */
export type GetAppLiteListResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Упрощённое приложение
   */
  readonly data: AppLiteResponseDto
  /**
   * Ошибка
   */
  readonly error: GetAppLiteListResponseErrorDto
}>
/**
 * Ошибка запроса получения списка приложений
 */
export type GetAppLiteListResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorRequestDto
}>
/**
 * Ошибка запроса получения списка приложений
 */
export type GetAppLiteListResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorResponseDto
}>
/**
 * Запрос получения упрощённого приложения
 */
export type GetAppLiteRequestDto = {
  /**
   * Идентификатор приложения.
   * # Тип: Guid
   */
  id: string
}
/**
 * Ответ на запрос получения упрощённого приложения
 */
export type GetAppLiteResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Упрощённое приложение
   */
  readonly data: AppLiteResponseDto
  /**
   * Ошибка
   */
  readonly error: GetAppLiteResponseErrorDto
}>
/**
 * Ошибка запроса получения упрощённого приложения
 */
export type GetAppLiteResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorRequestDto
}>
/**
 * Ошибка запроса получения упрощённого приложения
 */
export type GetAppLiteResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorResponseDto
}>
/**
 * Запрос получения приложения
 */
export type GetAppRequestDto = {
  /**
   * Идентификатор приложения.
   * # Тип: Guid
   */
  id: string
}
/**
 * Ответ на запрос получения приложения
 */
export type GetAppResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Приложение
   */
  readonly data: AppResponseDto
  /**
   * Ошибка
   */
  readonly error: GetAppResponseErrorDto
}>
/**
 * Ошибка запроса получения приложения
 */
export type GetAppResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorRequestDto
}>
/**
 * Ошибка запроса получения приложения
 */
export type GetAppResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorResponseDto
}>
/**
 * Запрос сохранения приложения
 */
export type PostAppRequestDto = {
  /**
   * Приложение
   */
  data: AppRequestDto
}
/**
 * Ответ на запрос сохранения приложения
 */
export type PostAppResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Приложение
   */
  readonly data: AppResponseDto
  /**
   * Ошибка
   */
  readonly error: PostAppResponseErrorDto
}>
/**
 * Ошибка запроса сохранения приложения
 */
export type PostAppResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorRequestDto
  /**
   * Ошибка сохранения
   */
  readonly saving: AppSavingErrorRequestDto
}>
/**
 * Ошибка запроса сохранения приложения
 */
export type PostAppResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorResponseDto
  /**
   * Ошибка сохранения
   */
  readonly saving: AppSavingErrorResponseDto
}>
/**
 * Ошибки валидации.
 * Эти проверки выполняются до обращения в базу данных
 */
export type ValidationErrorRequestDto = {
  /**
   * Путь к полю в формате наименования прото
   */
  path: string
  /**
   * Валидационное сообщение
   */
  message: string
}
/**
 * Ошибки валидации.
 * Эти проверки выполняются до обращения в базу данных
 */
export type ValidationErrorResponseDto = {
  /**
   * Путь к полю в формате наименования прото
   */
  path: string
  /**
   * Валидационное сообщение
   */
  message: string
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Приложение.
   * # Описание модели
   */
  "App": {
    "kind": "class",
    "text": "Приложение.\n# Описание модели",
    "fields": {
      /**
       * Идентификатор.
       * Если не передан создаётся сервером.
       * # Тип: Guid
       */
      "id": {
        "type": "string",
        "text": "Идентификатор.\nЕсли не передан создаётся сервером.\n# Тип: Guid",
      },
      /**
       * Идентификатор партнера.
       * # Тип: Guid
       */
      "partnerId": {
        "type": "string",
        "text": "Идентификатор партнера.\n# Тип: Guid",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Тип приложения
       */
      "type": {
        "type": "App.Type",
        "text": "Тип приложения",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Системное наименование.
       * Не отображается пользователям.
       * # Диапазон: 3..256
       */
      "title": {
        "type": "string",
        "text": "Системное наименование.\nНе отображается пользователям.\n# Диапазон: 3..256",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 3,
            "message": "Значение не входит в допустимый диапазон. Минимум: 3"
          },
          "maxLength": {
            "value": 256,
            "message": "Значение не входит в допустимый диапазон. Максимум: 256"
          },
        }
      },
      /**
       * Заголовок.
       * # Диапазон: 3..30
       */
      "header": {
        "type": "google.protobuf.StringValue",
        "text": "Заголовок.\n# Диапазон: 3..30",
        "rules": {
          "minLength": {
            "value": 3,
            "message": "Значение не входит в допустимый диапазон. Минимум: 3"
          },
          "maxLength": {
            "value": 30,
            "message": "Значение не входит в допустимый диапазон. Максимум: 30"
          },
        }
      },
      /**
       * Подзаголовок.
       * # Диапазон: 3..60
       */
      "subtitle": {
        "type": "google.protobuf.StringValue",
        "text": "Подзаголовок.\n# Диапазон: 3..60",
        "rules": {
          "minLength": {
            "value": 3,
            "message": "Значение не входит в допустимый диапазон. Минимум: 3"
          },
          "maxLength": {
            "value": 60,
            "message": "Значение не входит в допустимый диапазон. Максимум: 60"
          },
        }
      },
      /**
       * Цвет заднего плана(подложки).
       * Все цвета должны быть в формате hex #RRGGBBAA.
       * Пример: #7e00c380.
       * # Диапазон: 9..9.
       * # Паттерн: /^#[0-9a-fA-F]{8}$/
       */
      "backgroundColor": {
        "type": "google.protobuf.StringValue",
        "text": "Цвет заднего плана(подложки).\nВсе цвета должны быть в формате hex #RRGGBBAA.\nПример: #7e00c380.\n# Диапазон: 9..9.\n# Паттерн: /^#[0-9a-fA-F]{8}$/",
        "rules": {
          "minLength": {
            "value": 9,
            "message": "Значение не входит в допустимый диапазон. Минимум: 9"
          },
          "maxLength": {
            "value": 9,
            "message": "Значение не входит в допустимый диапазон. Максимум: 9"
          },
          "pattern": {
            "value": /^#[0-9a-fA-F]{8}$/,
            "message": "Значение не соответствует регулярному выражению. Паттерн: /^#[0-9a-fA-F]{8}$/"
          }
        }
      },
      /**
       * Статус приложения
       */
      "statusType": {
        "type": "App.StatusType",
        "text": "Статус приложения",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Ссылки для переходов.
       * # Диапазон: 0..100
       */
      "links": {
        "type": "App.Link",
        "text": "Ссылки для переходов.\n# Диапазон: 0..100",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 100,
            "message": "Значение не входит в допустимый диапазон. Максимум: 100"
          },
        }
      },
      /**
       * Список тегов пользователей.
       * Обязательное.
       * Описывает кто может видеть приложение.
       * Тэг - максимум 5 символов, значение - максимум 19 символов, количество сегментов - максимум 10.
       * # Диапазон: 1..100.
       * # Паттерн: /^[A-Z-]{1,5}_[0-9A-Z-]{1,19}(?:\.[A-Z-]{1,5}_[0-9A-Z-]{1,19}){0,9}$/
       */
      "userTags": {
        "type": "string",
        "text": "Список тегов пользователей.\nОбязательное.\nОписывает кто может видеть приложение.\nТэг - максимум 5 символов, значение - максимум 19 символов, количество сегментов - максимум 10.\n# Диапазон: 1..100.\n# Паттерн: /^[A-Z-]{1,5}_[0-9A-Z-]{1,19}(?:\.[A-Z-]{1,5}_[0-9A-Z-]{1,19}){0,9}$/",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "maxLength": {
            "value": 100,
            "message": "Значение не входит в допустимый диапазон. Максимум: 100"
          },
          "pattern": {
            "value": /^[A-Z-]{1,5}_[0-9A-Z-]{1,19}(?:\.[A-Z-]{1,5}_[0-9A-Z-]{1,19}){0,9}$/,
            "message": "Значение не соответствует регулярному выражению. Паттерн: /^[A-Z-]{1,5}_[0-9A-Z-]{1,19}(?:\.[A-Z-]{1,5}_[0-9A-Z-]{1,19}){0,9}$/"
          }
        }
      },
      /**
       * Список тегов приложений.
       * Обязательное.
       * Описывает какие клиенты могут видеть приложение.
       * Тэг - максимум 5 символов, значение - максимум 19 символов, количество сегментов - максимум 10.
       * # Диапазон: 1..20.
       * # Паттерн: /^[A-Z-]{1,5}_[0-9A-Z-]{1,19}(?:\.[A-Z-]{1,5}_[0-9A-Z-]{1,19}){0,9}$/
       */
      "appTags": {
        "type": "string",
        "text": "Список тегов приложений.\nОбязательное.\nОписывает какие клиенты могут видеть приложение.\nТэг - максимум 5 символов, значение - максимум 19 символов, количество сегментов - максимум 10.\n# Диапазон: 1..20.\n# Паттерн: /^[A-Z-]{1,5}_[0-9A-Z-]{1,19}(?:\.[A-Z-]{1,5}_[0-9A-Z-]{1,19}){0,9}$/",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "maxLength": {
            "value": 20,
            "message": "Значение не входит в допустимый диапазон. Максимум: 20"
          },
          "pattern": {
            "value": /^[A-Z-]{1,5}_[0-9A-Z-]{1,19}(?:\.[A-Z-]{1,5}_[0-9A-Z-]{1,19}){0,9}$/,
            "message": "Значение не соответствует регулярному выражению. Паттерн: /^[A-Z-]{1,5}_[0-9A-Z-]{1,19}(?:\.[A-Z-]{1,5}_[0-9A-Z-]{1,19}){0,9}$/"
          }
        }
      },
      /**
       * Дата создания.
       * # Тип: DateTime
       */
      "createdAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата создания.\n# Тип: DateTime",
      },
      /**
       * Дата последнего изменения.
       * Заполняется и обновляется сервером.
       * При изменении должен совпадать со значением из БД.
       * Является версией объекта.
       * # Тип: DateTime
       */
      "changedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата последнего изменения.\nЗаполняется и обновляется сервером.\nПри изменении должен совпадать со значением из БД.\nЯвляется версией объекта.\n# Тип: DateTime",
      },
      /**
       * Разрешения
       * @deprecated
       */
      "permissions": {
        "type": "App.Permissions",
        "text": "Разрешения",
      },
      /**
       * Список разрешений
       */
      "grantTypes": {
        "type": "App.GrantType",
        "text": "Список разрешений",
      },
    },
  },
  /**
   * Ссылка
   */
  "App.Link": {
    "kind": "class",
    "text": "Ссылка",
    "fields": {
      /**
       * Тип платформы.
       * Обязательное
       */
      "platformType": {
        "type": "App.PlatformType",
        "text": "Тип платформы.\nОбязательное",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Тип ссылки.
       * Обязательное
       */
      "type": {
        "type": "App.Link.Type",
        "text": "Тип ссылки.\nОбязательное",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Значение ссылки для перехода.
       * Обязательное.
       * # Диапазон: 12..512
       */
      "url": {
        "type": "string",
        "text": "Значение ссылки для перехода.\nОбязательное.\n# Диапазон: 12..512",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 12,
            "message": "Значение не входит в допустимый диапазон. Минимум: 12"
          },
          "maxLength": {
            "value": 512,
            "message": "Значение не входит в допустимый диапазон. Максимум: 512"
          },
        }
      },
      /**
       * Список пакетов.
       * Если пусто попытка перехода осуществляется безусловно.
       * Если заполнено, то переход осуществляется только в случае если хоть один пакет есть на устройстве, иначе обработка переходит к следующей ссылке.
       * # Диапазон: 0..20
       */
      "packages": {
        "type": "string",
        "text": "Список пакетов.\nЕсли пусто попытка перехода осуществляется безусловно.\nЕсли заполнено, то переход осуществляется только в случае если хоть один пакет есть на устройстве, иначе обработка переходит к следующей ссылке.\n# Диапазон: 0..20",
        "rules": {
          "minLength": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "maxLength": {
            "value": 20,
            "message": "Значение не входит в допустимый диапазон. Максимум: 20"
          },
        }
      },
    },
  },
  /**
   * Разрешения
   */
  "App.Permissions": {
    "kind": "class",
    "text": "Разрешения",
    "fields": {
      /**
       * Список разрешенных типов токена
       */
      "allowedTokenTypes": {
        "type": "App.Permissions.AllowedTokenType",
        "text": "Список разрешенных типов токена",
      },
    },
  },
  /**
   * Ошибка сохранения.
   * Эти проверки выполняются при работе с базой данных и сторонними сервисами
   */
  "App.SavingError": {
    "kind": "class",
    "text": "Ошибка сохранения.\nЭти проверки выполняются при работе с базой данных и сторонними сервисами",
    "fields": {
      /**
       * Конфликт версий
       */
      "conflict": {
        "type": "App.SavingError.Conflict",
        "text": "Конфликт версий",
      },
      /**
       * Переданный партнер не существует
       */
      "partnerIsNotExist": {
        "type": "App.SavingError.PartnerIsNotExist",
        "text": "Переданный партнер не существует",
      },
      /**
       * Переданный партнер удален
       */
      "partnerIsDeleted": {
        "type": "App.SavingError.PartnerIsDeleted",
        "text": "Переданный партнер удален",
      },
    },
  },
  /**
   * Конфликт версий.
   * Причины:
   * - В базе хранится другая версия строки, значения changed_at отличаются
   */
  "App.SavingError.Conflict": {
    "kind": "class",
    "text": "Конфликт версий.\nПричины:\n- В базе хранится другая версия строки, значения changed_at отличаются",
  },
  /**
   * Переданный партнер удален.
   * Причины:
   * - В базе удален партнер с переданным partner_id
   */
  "App.SavingError.PartnerIsDeleted": {
    "kind": "class",
    "text": "Переданный партнер удален.\nПричины:\n- В базе удален партнер с переданным partner_id",
  },
  /**
   * Переданный партнер не существует.
   * Причины:
   * - В базе нет партнера с переданным partner_id
   */
  "App.SavingError.PartnerIsNotExist": {
    "kind": "class",
    "text": "Переданный партнер не существует.\nПричины:\n- В базе нет партнера с переданным partner_id",
  },
  /**
   * Фильтр приложений
   */
  "AppFilter": {
    "kind": "class",
    "text": "Фильтр приложений",
    "fields": {
      /**
       * По тексту.
       * Если значение не передано то поиск по нему не производится.
       * # Диапазон: 3..64.
       * # Поиск производится по полям:
       * # - Системное наименование;
       * # - Заголовок;
       * # - Подзаголовок;
       * # - Список тегов пользователей;
       * # - Список тегов приложений
       */
      "text": {
        "type": "google.protobuf.StringValue",
        "text": "По тексту.\nЕсли значение не передано то поиск по нему не производится.\n# Диапазон: 3..64.\n# Поиск производится по полям:\n# - Системное наименование;\n# - Заголовок;\n# - Подзаголовок;\n# - Список тегов пользователей;\n# - Список тегов приложений",
        "rules": {
          "minLength": {
            "value": 3,
            "message": "Значение не входит в допустимый диапазон. Минимум: 3"
          },
          "maxLength": {
            "value": 64,
            "message": "Значение не входит в допустимый диапазон. Максимум: 64"
          },
        }
      },
      /**
       * По типам приложений
       */
      "types": {
        "type": "App.Type",
        "text": "По типам приложений",
      },
      /**
       * По идентификаторам партнера.
       * # Тип: Guid
       */
      "partnerIds": {
        "type": "string",
        "text": "По идентификаторам партнера.\n# Тип: Guid",
      },
      /**
       * По статусам приложений.
       * Если переданы все типы, то фильтр игнорируется(так как нужно вернуть всё)
       */
      "statusTypes": {
        "type": "App.StatusType",
        "text": "По статусам приложений.\nЕсли переданы все типы, то фильтр игнорируется(так как нужно вернуть всё)",
      },
      /**
       * По пользовательским тегам.
       * Тэг - максимум 5 символов, значение - максимум 19 символов, количество сегментов - максимум 10.
       * # Диапазон: 0..20.
       * # Паттерн: /^[A-Z-]{1,5}_[0-9A-Z-]{1,19}(?:\.[A-Z-]{1,5}_[0-9A-Z-]{1,19}){0,9}$/
       */
      "userTags": {
        "type": "string",
        "text": "По пользовательским тегам.\nТэг - максимум 5 символов, значение - максимум 19 символов, количество сегментов - максимум 10.\n# Диапазон: 0..20.\n# Паттерн: /^[A-Z-]{1,5}_[0-9A-Z-]{1,19}(?:\.[A-Z-]{1,5}_[0-9A-Z-]{1,19}){0,9}$/",
        "rules": {
          "minLength": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "maxLength": {
            "value": 20,
            "message": "Значение не входит в допустимый диапазон. Максимум: 20"
          },
          "pattern": {
            "value": /^[A-Z-]{1,5}_[0-9A-Z-]{1,19}(?:\.[A-Z-]{1,5}_[0-9A-Z-]{1,19}){0,9}$/,
            "message": "Значение не соответствует регулярному выражению. Паттерн: /^[A-Z-]{1,5}_[0-9A-Z-]{1,19}(?:\.[A-Z-]{1,5}_[0-9A-Z-]{1,19}){0,9}$/"
          }
        }
      },
      /**
       * По тегам приложений.
       * Тэг - максимум 5 символов, значение - максимум 19 символов, количество сегментов - максимум 10.
       * # Диапазон: 0..20.
       * # Паттерн: /^[A-Z-]{1,5}_[0-9A-Z-]{1,19}(?:\.[A-Z-]{1,5}_[0-9A-Z-]{1,19}){0,9}$/
       */
      "appTags": {
        "type": "string",
        "text": "По тегам приложений.\nТэг - максимум 5 символов, значение - максимум 19 символов, количество сегментов - максимум 10.\n# Диапазон: 0..20.\n# Паттерн: /^[A-Z-]{1,5}_[0-9A-Z-]{1,19}(?:\.[A-Z-]{1,5}_[0-9A-Z-]{1,19}){0,9}$/",
        "rules": {
          "minLength": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "maxLength": {
            "value": 20,
            "message": "Значение не входит в допустимый диапазон. Максимум: 20"
          },
          "pattern": {
            "value": /^[A-Z-]{1,5}_[0-9A-Z-]{1,19}(?:\.[A-Z-]{1,5}_[0-9A-Z-]{1,19}){0,9}$/,
            "message": "Значение не соответствует регулярному выражению. Паттерн: /^[A-Z-]{1,5}_[0-9A-Z-]{1,19}(?:\.[A-Z-]{1,5}_[0-9A-Z-]{1,19}){0,9}$/"
          }
        }
      },
    },
  },
  /**
   * Облегчённое приложение
   */
  "AppLite": {
    "kind": "class",
    "text": "Облегчённое приложение",
    "fields": {
      /**
       * Идентификатор.
       * # Тип: Guid
       */
      "id": {
        "type": "string",
        "text": "Идентификатор.\n# Тип: Guid",
      },
      /**
       * Наименование.
       * Не отображается пользователям.
       * # Диапазон: 3..256
       */
      "title": {
        "type": "string",
        "text": "Наименование.\nНе отображается пользователям.\n# Диапазон: 3..256",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 3,
            "message": "Значение не входит в допустимый диапазон. Минимум: 3"
          },
          "maxLength": {
            "value": 256,
            "message": "Значение не входит в допустимый диапазон. Максимум: 256"
          },
        }
      },
      /**
       * Заголовок.
       * # Диапазон: 3..30
       */
      "header": {
        "type": "google.protobuf.StringValue",
        "text": "Заголовок.\n# Диапазон: 3..30",
        "rules": {
          "minLength": {
            "value": 3,
            "message": "Значение не входит в допустимый диапазон. Минимум: 3"
          },
          "maxLength": {
            "value": 30,
            "message": "Значение не входит в допустимый диапазон. Максимум: 30"
          },
        }
      },
      /**
       * Подзаголовок.
       * # Диапазон: 3..60
       */
      "subtitle": {
        "type": "google.protobuf.StringValue",
        "text": "Подзаголовок.\n# Диапазон: 3..60",
        "rules": {
          "minLength": {
            "value": 3,
            "message": "Значение не входит в допустимый диапазон. Минимум: 3"
          },
          "maxLength": {
            "value": 60,
            "message": "Значение не входит в допустимый диапазон. Максимум: 60"
          },
        }
      },
      /**
       * Цвет заднего плана(подложки).
       * Все цвета должны быть в формате hex #RRGGBBAA.
       * Пример: #7e00c380.
       * # Диапазон: 9..9.
       * # Паттерн: /^#[0-9a-fA-F]{8}$/
       */
      "backgroundColor": {
        "type": "google.protobuf.StringValue",
        "text": "Цвет заднего плана(подложки).\nВсе цвета должны быть в формате hex #RRGGBBAA.\nПример: #7e00c380.\n# Диапазон: 9..9.\n# Паттерн: /^#[0-9a-fA-F]{8}$/",
        "rules": {
          "minLength": {
            "value": 9,
            "message": "Значение не входит в допустимый диапазон. Минимум: 9"
          },
          "maxLength": {
            "value": 9,
            "message": "Значение не входит в допустимый диапазон. Максимум: 9"
          },
          "pattern": {
            "value": /^#[0-9a-fA-F]{8}$/,
            "message": "Значение не соответствует регулярному выражению. Паттерн: /^#[0-9a-fA-F]{8}$/"
          }
        }
      },
      /**
       * Статус приложения
       */
      "statusType": {
        "type": "App.StatusType",
        "text": "Статус приложения",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Ссылки для переходов
       */
      "links": {
        "type": "AppLite.LinkLite",
        "text": "Ссылки для переходов",
      },
    },
  },
  /**
   * Упрощённая ссылка
   */
  "AppLite.LinkLite": {
    "kind": "class",
    "text": "Упрощённая ссылка",
    "fields": {
      /**
       * Тип платформы.
       * Обязательное
       */
      "platformType": {
        "type": "App.PlatformType",
        "text": "Тип платформы.\nОбязательное",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Тип ссылки.
       * Обязательное
       */
      "type": {
        "type": "App.Link.Type",
        "text": "Тип ссылки.\nОбязательное",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Значение ссылки для перехода.
       * Обязательное
       */
      "url": {
        "type": "string",
        "text": "Значение ссылки для перехода.\nОбязательное",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Список пакетов.
       * Если пусто попытка перехода осуществляется безусловно.
       * Если заполнено, то переход осуществляется только в случае если хоть один пакет есть на устройстве, иначе обработка переходит к следующей ссылке
       */
      "packages": {
        "type": "string",
        "text": "Список пакетов.\nЕсли пусто попытка перехода осуществляется безусловно.\nЕсли заполнено, то переход осуществляется только в случае если хоть один пакет есть на устройстве, иначе обработка переходит к следующей ссылке",
      },
    },
  },
  /**
   * Упрощённый фильтр по приложениям
   */
  "AppLiteFilter": {
    "kind": "class",
    "text": "Упрощённый фильтр по приложениям",
    "fields": {
      /**
       * По типам приложений
       */
      "types": {
        "type": "App.Type",
        "text": "По типам приложений",
      },
      /**
       * По тегам пользователя.
       * Тэг - максимум 5 символов, значение - максимум 19 символов, количество сегментов - максимум 10.
       * # Диапазон: 1..20.
       * # Паттерн: /^[A-Z-]{1,5}_[0-9A-Z-]{1,19}(?:\.[A-Z-]{1,5}_[0-9A-Z-]{1,19}){0,9}$/
       */
      "userTags": {
        "type": "string",
        "text": "По тегам пользователя.\nТэг - максимум 5 символов, значение - максимум 19 символов, количество сегментов - максимум 10.\n# Диапазон: 1..20.\n# Паттерн: /^[A-Z-]{1,5}_[0-9A-Z-]{1,19}(?:\.[A-Z-]{1,5}_[0-9A-Z-]{1,19}){0,9}$/",
        "rules": {
          "minLength": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "maxLength": {
            "value": 20,
            "message": "Значение не входит в допустимый диапазон. Максимум: 20"
          },
          "pattern": {
            "value": /^[A-Z-]{1,5}_[0-9A-Z-]{1,19}(?:\.[A-Z-]{1,5}_[0-9A-Z-]{1,19}){0,9}$/,
            "message": "Значение не соответствует регулярному выражению. Паттерн: /^[A-Z-]{1,5}_[0-9A-Z-]{1,19}(?:\.[A-Z-]{1,5}_[0-9A-Z-]{1,19}){0,9}$/"
          }
        }
      },
      /**
       * Тег для приложения
       */
      "appLiteTag": {
        "type": "AppLiteFilter.AppLiteTag",
        "text": "Тег для приложения",
      },
    },
  },
  /**
   * Тег для приложения
   */
  "AppLiteFilter.AppLiteTag": {
    "kind": "class",
    "text": "Тег для приложения",
    "fields": {
      /**
       * Тип платформы
       */
      "platformType": {
        "type": "App.PlatformType",
        "text": "Тип платформы",
      },
      /**
       * Название приложения, которое работает с данным сервисом.
       * Для МП и PWA значение \"1\".
       * # Паттерн: /^[0-9A-Z-]{1,19}$/
       */
      "appName": {
        "type": "google.protobuf.StringValue",
        "text": "Название приложения, которое работает с данным сервисом.\nДля МП и PWA значение \"1\".\n# Паттерн: /^[0-9A-Z-]{1,19}$/",
        "rules": {
          "pattern": {
            "value": /^[0-9A-Z-]{1,19}$/,
            "message": "Значение не соответствует регулярному выражению. Паттерн: /^[0-9A-Z-]{1,19}$/"
          }
        }
      },
    },
  },
  /**
   * Пагинация упрощенных приложений
   */
  "AppLitePaging": {
    "kind": "class",
    "text": "Пагинация упрощенных приложений",
    "fields": {
      /**
       * Тип значения сортировки.
       * Если значение не передано, то будет взято значение по умолчанию.
       * # По умолчанию: CREATED_AT
       */
      "orderByType": {
        "type": "AppLitePaging.OrderByType",
        "text": "Тип значения сортировки.\nЕсли значение не передано, то будет взято значение по умолчанию.\n# По умолчанию: CREATED_AT",
      },
      /**
       * Тип направления сортировки.
       * # По умолчанию: DESC
       */
      "directionType": {
        "type": "AppLitePaging.DirectionType",
        "text": "Тип направления сортировки.\n# По умолчанию: DESC",
      },
      /**
       * Количество записей на страницу.
       * Если значение 0 (не передано), то будет взято значение по умолчанию.
       * # Диапазон: 0..100.
       * # По умолчанию: 20
       */
      "limit": {
        "type": "int32",
        "text": "Количество записей на страницу.\nЕсли значение 0 (не передано), то будет взято значение по умолчанию.\n# Диапазон: 0..100.\n# По умолчанию: 20",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 100,
            "message": "Значение не входит в допустимый диапазон. Максимум: 100"
          },
        }
      },
      /**
       * Сдвиг.
       * # Диапазон: 0..2147483647
       */
      "offset": {
        "type": "int32",
        "text": "Сдвиг.\n# Диапазон: 0..2147483647",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
    },
  },
  /**
   * Пагинация приложений
   */
  "AppPaging": {
    "kind": "class",
    "text": "Пагинация приложений",
    "fields": {
      /**
       * Тип значения сортировки.
       * Если значение не передано, то будет взято значение по умолчанию.
       * # По умолчанию: CHANGED_AT
       */
      "orderByType": {
        "type": "AppPaging.OrderByType",
        "text": "Тип значения сортировки.\nЕсли значение не передано, то будет взято значение по умолчанию.\n# По умолчанию: CHANGED_AT",
      },
      /**
       * Тип направления сортировки.
       * # По умолчанию: DESC
       */
      "directionType": {
        "type": "AppPaging.DirectionType",
        "text": "Тип направления сортировки.\n# По умолчанию: DESC",
      },
      /**
       * Количество записей на страницу.
       * Если значение 0 (не передано), то будет взято значение по умолчанию.
       * # Диапазон: 0..100.
       * # По умолчанию: 20
       */
      "limit": {
        "type": "int32",
        "text": "Количество записей на страницу.\nЕсли значение 0 (не передано), то будет взято значение по умолчанию.\n# Диапазон: 0..100.\n# По умолчанию: 20",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 100,
            "message": "Значение не входит в допустимый диапазон. Максимум: 100"
          },
        }
      },
      /**
       * Сдвиг.
       * # Диапазон: 0..2147483647
       */
      "offset": {
        "type": "int32",
        "text": "Сдвиг.\n# Диапазон: 0..2147483647",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
    },
  },
  /**
   * Запрос удаления приложения
   */
  "DeleteAppRequest": {
    "kind": "class",
    "text": "Запрос удаления приложения",
    "fields": {
      /**
       * Идентификатор приложения.
       * # Тип: Guid
       */
      "id": {
        "type": "string",
        "text": "Идентификатор приложения.\n# Тип: Guid",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос удаления приложения
   */
  "DeleteAppResponse": {
    "kind": "class",
    "text": "Ответ на запрос удаления приложения",
    "fields": {
      /**
       * Ошибка
       */
      "error": {
        "type": "DeleteAppResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса получения упрощённого приложения
   */
  "DeleteAppResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса получения упрощённого приложения",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос на получение кода для перехода в приложение
   */
  "GetAppCodeRequest": {
    "kind": "class",
    "text": "Запрос на получение кода для перехода в приложение",
    "fields": {
      /**
       * Идентификатор приложения.
       * # Тип: Guid
       */
      "id": {
        "type": "string",
        "text": "Идентификатор приложения.\n# Тип: Guid",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос на получение кода для перехода в приложение
   */
  "GetAppCodeResponse": {
    "kind": "class",
    "text": "Ответ на запрос на получение кода для перехода в приложение",
    "fields": {
      /**
       * Код
       */
      "data": {
        "type": "string",
        "text": "Код",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetAppCodeResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса получения ссылки на приложение
   */
  "GetAppCodeResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса получения ссылки на приложение",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
      /**
       * Ошибка наличия публичного ключа у партнера
       */
      "partnerKeyDoesNotExist": {
        "type": "GetAppCodeResponse.Error.PartnerKeyDoesNotExist",
        "text": "Ошибка наличия публичного ключа у партнера",
      },
      /**
       * Приложение не в статусе ACTIVE
       */
      "appIsInactive": {
        "type": "GetAppCodeResponse.Error.AppIsInactive",
        "text": "Приложение не в статусе ACTIVE",
      },
    },
  },
  /**
   * Приложение не в статусе ACTIVE
   */
  "GetAppCodeResponse.Error.AppIsInactive": {
    "kind": "class",
    "text": "Приложение не в статусе ACTIVE",
  },
  /**
   * Ошибка наличия публичного ключа у партнера
   */
  "GetAppCodeResponse.Error.PartnerKeyDoesNotExist": {
    "kind": "class",
    "text": "Ошибка наличия публичного ключа у партнера",
  },
  /**
   * Запрос получения количества приложений
   */
  "GetAppCountRequest": {
    "kind": "class",
    "text": "Запрос получения количества приложений",
    "fields": {
      /**
       * Фильтр
       */
      "filter": {
        "type": "AppFilter",
        "text": "Фильтр",
      },
    },
  },
  /**
   * Ответ на запрос получения количества приложений
   */
  "GetAppCountResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения количества приложений",
    "fields": {
      /**
       * Всего приложений
       */
      "data": {
        "type": "int32",
        "text": "Всего приложений",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetAppCountResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса получения количества приложений
   */
  "GetAppCountResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса получения количества приложений",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос получения списка приложений
   */
  "GetAppListRequest": {
    "kind": "class",
    "text": "Запрос получения списка приложений",
    "fields": {
      /**
       * Фильтр
       */
      "filter": {
        "type": "AppFilter",
        "text": "Фильтр",
      },
      /**
       * Пагинация
       */
      "paging": {
        "type": "AppPaging",
        "text": "Пагинация",
      },
    },
  },
  /**
   * Ответ на запрос получения списка приложений
   */
  "GetAppListResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения списка приложений",
    "fields": {
      /**
       * Приложение
       */
      "data": {
        "type": "App",
        "text": "Приложение",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetAppListResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса получения списка приложений
   */
  "GetAppListResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса получения списка приложений",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос получения количества упрощённых приложений
   */
  "GetAppLiteCountRequest": {
    "kind": "class",
    "text": "Запрос получения количества упрощённых приложений",
    "fields": {
      /**
       * Упрощённый фильтр
       */
      "filter": {
        "type": "AppLiteFilter",
        "text": "Упрощённый фильтр",
      },
    },
  },
  /**
   * Ответ на запрос получения количества упрощённых приложений
   */
  "GetAppLiteCountResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения количества упрощённых приложений",
    "fields": {
      /**
       * Всего упрощенных приложений
       */
      "data": {
        "type": "int32",
        "text": "Всего упрощенных приложений",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetAppLiteCountResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса получения списка приложений
   */
  "GetAppLiteCountResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса получения списка приложений",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос получения списка упрощённого приложений
   */
  "GetAppLiteListRequest": {
    "kind": "class",
    "text": "Запрос получения списка упрощённого приложений",
    "fields": {
      /**
       * Упрощённый фильтр
       */
      "filter": {
        "type": "AppLiteFilter",
        "text": "Упрощённый фильтр",
      },
      /**
       * Пагинация
       */
      "paging": {
        "type": "AppLitePaging",
        "text": "Пагинация",
      },
    },
  },
  /**
   * Ответ на запрос получения списка упрощённых приложений
   */
  "GetAppLiteListResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения списка упрощённых приложений",
    "fields": {
      /**
       * Упрощённое приложение
       */
      "data": {
        "type": "AppLite",
        "text": "Упрощённое приложение",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetAppLiteListResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса получения списка приложений
   */
  "GetAppLiteListResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса получения списка приложений",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос получения упрощённого приложения
   */
  "GetAppLiteRequest": {
    "kind": "class",
    "text": "Запрос получения упрощённого приложения",
    "fields": {
      /**
       * Идентификатор приложения.
       * # Тип: Guid
       */
      "id": {
        "type": "string",
        "text": "Идентификатор приложения.\n# Тип: Guid",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос получения упрощённого приложения
   */
  "GetAppLiteResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения упрощённого приложения",
    "fields": {
      /**
       * Упрощённое приложение
       */
      "data": {
        "type": "AppLite",
        "text": "Упрощённое приложение",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetAppLiteResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса получения упрощённого приложения
   */
  "GetAppLiteResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса получения упрощённого приложения",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос получения приложения
   */
  "GetAppRequest": {
    "kind": "class",
    "text": "Запрос получения приложения",
    "fields": {
      /**
       * Идентификатор приложения.
       * # Тип: Guid
       */
      "id": {
        "type": "string",
        "text": "Идентификатор приложения.\n# Тип: Guid",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос получения приложения
   */
  "GetAppResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения приложения",
    "fields": {
      /**
       * Приложение
       */
      "data": {
        "type": "App",
        "text": "Приложение",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetAppResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса получения приложения
   */
  "GetAppResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса получения приложения",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос сохранения приложения
   */
  "PostAppRequest": {
    "kind": "class",
    "text": "Запрос сохранения приложения",
    "fields": {
      /**
       * Приложение
       */
      "data": {
        "type": "App",
        "text": "Приложение",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос сохранения приложения
   */
  "PostAppResponse": {
    "kind": "class",
    "text": "Ответ на запрос сохранения приложения",
    "fields": {
      /**
       * Приложение
       */
      "data": {
        "type": "App",
        "text": "Приложение",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "PostAppResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса сохранения приложения
   */
  "PostAppResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса сохранения приложения",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
      /**
       * Ошибка сохранения
       */
      "saving": {
        "type": "App.SavingError",
        "text": "Ошибка сохранения",
      },
    },
  },
  /**
   * Ошибки валидации.
   * Эти проверки выполняются до обращения в базу данных
   */
  "ValidationError": {
    "kind": "class",
    "text": "Ошибки валидации.\nЭти проверки выполняются до обращения в базу данных",
    "fields": {
      /**
       * Путь к полю в формате наименования прото
       */
      "path": {
        "type": "string",
        "text": "Путь к полю в формате наименования прото",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Валидационное сообщение
       */
      "message": {
        "type": "string",
        "text": "Валидационное сообщение",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Справочник разрешений
   */
  "App.GrantType": {
    "kind": "enum",
    "text": "Справочник разрешений",
    "values": {
      /**
       * Значение не указано
       */
      "GRANT_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Разрешение на получение авторизационного токена посредством метода GET /multiapp/api/v1/partner/token
       */
      "GET_ACCESS_TOKEN": {
        "i": 1,
        "text": "Разрешение на получение авторизационного токена посредством метода GET /multiapp/api/v1/partner/token",
      },
      /**
       * Разрешение на получение идентификационного доступа посредством метода GET /multiapp/api/v1/partner/token
       */
      "GET_ID_TOKEN": {
        "i": 2,
        "text": "Разрешение на получение идентификационного доступа посредством метода GET /multiapp/api/v1/partner/token",
      },
      /**
       * Разрешение на отправку уведомлений без проверки назначений приложения методом POST /multiapp/api/v1/notification
       */
      "POST_NOTIF_NO_ASSIGN_CHECK": {
        "i": 3,
        "text": "Разрешение на отправку уведомлений без проверки назначений приложения методом POST /multiapp/api/v1/notification",
      },
    },
  },
  /**
   * Справочник типов ссылок.
   */
  "App.Link.Type": {
    "kind": "enum",
    "text": "Справочник типов ссылок.",
    "values": {
      /**
       * Значение не указано
       */
      "TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Ссылка для перехода на раздел текущего приложения
       */
      "INTERNAL_APP": {
        "i": 1,
        "text": "Ссылка для перехода на раздел текущего приложения",
      },
      /**
       * Ссылка для перехода на стороннее приложение
       */
      "EXTERNAL_APP": {
        "i": 2,
        "text": "Ссылка для перехода на стороннее приложение",
      },
      /**
       * Ссылка для перехода на веб-вью внутренних (своих) приложений.
       * В окне отсутствует адресаная строка.
       * Для iOS используется WKWebView, для Android используется WebView
       */
      "WEB_VIEW": {
        "i": 3,
        "text": "Ссылка для перехода на веб-вью внутренних (своих) приложений.\nВ окне отсутствует адресаная строка.\nДля iOS используется WKWebView, для Android используется WebView",
      },
      /**
       * Ссылка для перехода на веб-браузер
       */
      "WEB_BROWSER": {
        "i": 4,
        "text": "Ссылка для перехода на веб-браузер",
      },
      /**
       * Ссылка для перехода на веб-вью внешних (партнёрских) приложений.
       * В окне присутствует адресаная строка.
       * Для iOS используется SFSafariViewController, для Android используется ChromeCustomTabs
       */
      "EXTERNAL_WEB_VIEW": {
        "i": 5,
        "text": "Ссылка для перехода на веб-вью внешних (партнёрских) приложений.\nВ окне присутствует адресаная строка.\nДля iOS используется SFSafariViewController, для Android используется ChromeCustomTabs",
      },
    },
  },
  /**
   * Справочник разрешенных типов токена
   */
  "App.Permissions.AllowedTokenType": {
    "kind": "enum",
    "text": "Справочник разрешенных типов токена",
    "values": {
      /**
       * Значение не указано
       */
      "ALLOWED_TOKEN_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Идентификационный
       */
      "ID": {
        "i": 1,
        "text": "Идентификационный",
      },
      /**
       * Авторизационный
       */
      "ACCESS": {
        "i": 2,
        "text": "Авторизационный",
      },
    },
  },
  /**
   * Справочник платформ.
   */
  "App.PlatformType": {
    "kind": "enum",
    "text": "Справочник платформ.",
    "values": {
      /**
       * Значение не указано
       */
      "PLATFORM_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Платформа iOS.
       * Приложение размещается в App Store
       */
      "IOS": {
        "i": 1,
        "text": "Платформа iOS.\nПриложение размещается в App Store",
      },
      /**
       * Платформа Android.
       * Приложение размещается в Google Play, App Gallery или прочих сторах
       */
      "ANDROID": {
        "i": 2,
        "text": "Платформа Android.\nПриложение размещается в Google Play, App Gallery или прочих сторах",
      },
      /**
       * Платформа Web.
       * Приложение размещается по интернет адресу
       */
      "WEB": {
        "i": 3,
        "text": "Платформа Web.\nПриложение размещается по интернет адресу",
      },
    },
  },
  /**
   * Справочник статусов приложений.
   */
  "App.StatusType": {
    "kind": "enum",
    "text": "Справочник статусов приложений.",
    "values": {
      /**
       * Значение не указано
       */
      "STATUS_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Заблокирован
       */
      "BLOCKED": {
        "i": 1,
        "text": "Заблокирован",
      },
      /**
       * Активен
       */
      "ACTIVE": {
        "i": 2,
        "text": "Активен",
      },
      /**
       * Удален
       */
      "DELETED": {
        "i": 3,
        "text": "Удален",
      },
    },
  },
  /**
   * Справочник типов приложений.
   */
  "App.Type": {
    "kind": "enum",
    "text": "Справочник типов приложений.",
    "values": {
      /**
       * Значение не указано
       */
      "TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Стандартное приложение
       */
      "STANDARD": {
        "i": 1,
        "text": "Стандартное приложение",
      },
    },
  },
  /**
   * Справочник типов направлений сортировки.
   */
  "AppLitePaging.DirectionType": {
    "kind": "enum",
    "text": "Справочник типов направлений сортировки.",
    "values": {
      /**
       * Значение не указано
       */
      "DIRECTION_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * От большего к меньшему
       */
      "DESC": {
        "i": 1,
        "text": "От большего к меньшему",
      },
      /**
       * От меньшего к большему
       */
      "ASC": {
        "i": 2,
        "text": "От меньшего к большему",
      },
    },
  },
  /**
   * Справочник типов значений сортировки.
   */
  "AppLitePaging.OrderByType": {
    "kind": "enum",
    "text": "Справочник типов значений сортировки.",
    "values": {
      /**
       * Значение не указано
       */
      "ORDER_BY_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Дата последнего изменения
       */
      "CHANGED_AT": {
        "i": 1,
        "text": "Дата последнего изменения",
      },
      /**
       * Дата создания
       */
      "CREATED_AT": {
        "i": 2,
        "text": "Дата создания",
      },
    },
  },
  /**
   * Справочник типов направлений сортировки.
   */
  "AppPaging.DirectionType": {
    "kind": "enum",
    "text": "Справочник типов направлений сортировки.",
    "values": {
      /**
       * Значение не указано
       */
      "DIRECTION_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * От большего к меньшему
       */
      "DESC": {
        "i": 1,
        "text": "От большего к меньшему",
      },
      /**
       * От меньшего к большему
       */
      "ASC": {
        "i": 2,
        "text": "От меньшего к большему",
      },
    },
  },
  /**
   * Справочник типов значений сортировки.
   */
  "AppPaging.OrderByType": {
    "kind": "enum",
    "text": "Справочник типов значений сортировки.",
    "values": {
      /**
       * Значение не указано
       */
      "ORDER_BY_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Дата последнего изменения
       */
      "CHANGED_AT": {
        "i": 1,
        "text": "Дата последнего изменения",
      },
      /**
       * Дата создания
       */
      "CREATED_AT": {
        "i": 2,
        "text": "Дата создания",
      },
      /**
       * По рангу для поиска по тексту.
       * Применяется когда передано поле для поиска по тексту.
       * В случае если текстовое поле не передано, применяется значение по умолчанию
       */
      "RANK": {
        "i": 3,
        "text": "По рангу для поиска по тексту.\nПрименяется когда передано поле для поиска по тексту.\nВ случае если текстовое поле не передано, применяется значение по умолчанию",
      },
    },
  },
}